import { render, staticRenderFns } from "./AwardLumpSum.vue?vue&type=template&id=0146ac62"
import script from "./AwardLumpSum.vue?vue&type=script&lang=js"
export * from "./AwardLumpSum.vue?vue&type=script&lang=js"
import style0 from "./AwardLumpSum.vue?vue&type=style&index=0&id=0146ac62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports